/**
 * "Trusted by" wordmark strip — Luminous Atrium styling.
 * Infinite horizontal marquee of sans wordmarks, with edge fades
 * to keep the calm, modern feel.
 */
export const EditorialLogoBar = () => {
  const wordmarks = [
    "CloudScale",
    "RemoteFirst",
    "PayStream",
    "Northwind HR",
    "Lattice & Co.",
    "Beacon Health",
  ];

  // Duplicate the list so the translate -50% loop is seamless.
  const track = [...wordmarks, ...wordmarks];

  return (
    <section
      aria-label="Companies using SendFeedback"
      className="bg-background border-y border-border/60 px-4 sm:px-6 md:px-10 py-12 md:py-16 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          background:
            "radial-gradient(700px 320px at 50% 0%, hsl(50 60% 92% / 0.4), transparent 60%)",
        }}
      />
      <div className="max-w-7xl mx-auto relative">
        <div className="flex items-center justify-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-2 rounded-full border border-border/60 bg-background/70 backdrop-blur px-3.5 py-1.5 text-[10px] sm:text-[11px] uppercase tracking-[0.22em] font-medium text-foreground/70 shadow-[0_2px_8px_-4px_rgba(21,34,27,0.06)]">
            <span className="h-1.5 w-1.5 rounded-full bg-primary" />
            Trusted by People teams at
          </span>
        </div>

        {/* Marquee */}
        <div
          className="group relative overflow-hidden"
          style={{
            maskImage:
              "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
            WebkitMaskImage:
              "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          }}
        >
          <ul
            className="flex w-max items-center gap-x-10 sm:gap-x-14 md:gap-x-20 animate-[atrium-marquee_38s_linear_infinite] group-hover:[animation-play-state:paused] motion-reduce:animate-none"
          >
            {track.map((name, i) => (
              <li
                key={`${name}-${i}`}
                aria-hidden={i >= wordmarks.length ? true : undefined}
                className="font-sans text-lg sm:text-xl md:text-2xl font-medium tracking-[-0.01em] leading-none text-foreground/45 hover:text-foreground transition-colors duration-300 whitespace-nowrap"
              >
                {name}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style>{`
        @keyframes atrium-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
};
